export const privacy = {
  title: 'Política de privacidade',
  description: 'Como o Pila trata nome, e-mail, CPF, lançamentos da casa, pagamento no Stripe, WhatsApp e a chave de inteligência.',
  sections: [
    {
      heading: 'Quem trata os dados',
      paragraphs: [
        'O Pila é o serviço de contas da casa da Fontes Business, no endereço pila.fontes.business. O assinante é quem abre a casa e responde pelos dados lançados nela.',
      ],
    },
    {
      heading: 'O que é coletado',
      paragraphs: [
        'Cadastro: nome, e-mail, senha, celular e CPF. No onboarding da casa, data de nascimento e endereço, com consulta de CEP.',
        'Uso: despesas, receitas, categorias, objetivos, lembretes, anexos de boleto e comprovante, e o registro de quem pagou.',
        'Assinatura: o cartão é informado na tela do site e processado pelo Stripe. O Pila não guarda o número completo do cartão.',
        'Opcionais: número de WhatsApp, se a pessoa conectar o próprio aparelho, e a chave de inteligência artificial que o assinante cadastrar. A chave fica criptografada e só o assinante pode revelá-la.',
      ],
    },
    {
      heading: 'Para que serve',
      paragraphs: [
        'Para abrir a casa, cobrar o plano, mostrar o mês, avisar vencimentos e deixar cada pessoa da mesma assinatura ver o que foi combinado. A inteligência artificial só é usada quando o assinante grava uma chave.',
      ],
    },
    {
      heading: 'Com quem os dados são compartilhados',
      paragraphs: [
        'Com as pessoas convidadas para a mesma casa. Uma casa não vê os lançamentos de outra.',
        'Com o Stripe, para o pagamento. Com o provedor de e-mail, para convite e recuperação de senha. Com a Evolution API, só se a pessoa conectar o WhatsApp. Com OpenAI, Gemini ou Claude, só se o assinante informar a chave daquele provedor.',
      ],
    },
    {
      heading: 'Por quanto tempo',
      paragraphs: [
        'Enquanto a conta existir e pelo prazo necessário para cumprir obrigação legal. Lançamentos excluídos podem permanecer em exclusão lógica até a limpeza da casa. O assinante pode pedir a exclusão da conta.',
      ],
    },
    {
      heading: 'Os direitos de quem usa',
      paragraphs: [
        'A pessoa pode acessar, corrigir e pedir a exclusão dos dados da casa, além de revogar o WhatsApp e apagar a chave de inteligência. O pedido vai para contato@fontes.business.',
        'O Pila não é dirigido a crianças. O CPF e os dados da casa são do assinante adulto que abre a conta.',
      ],
    },
  ],
}

export const terms = {
  title: 'Termos de uso',
  description: 'Regras do Pila: plano Família de R$ 79,90, até cinco pessoas, assinatura no site e uso da casa.',
  sections: [
    {
      heading: 'O serviço',
      paragraphs: [
        'O Pila organiza as contas de uma casa: despesas, receitas, quem pagou, categorias, objetivos, lembretes e, se o assinante quiser, avisos no WhatsApp e leitura com a chave de inteligência que ele mesmo cadastrar. Não há conexão com banco.',
      ],
    },
    {
      heading: 'A conta e o plano',
      paragraphs: [
        'O plano Família custa R$ 79,90 por mês e inclui até cinco pessoas ativas. A conta abre na hora e o pagamento no site libera a casa. O cancelamento pode ser feito quando o assinante quiser. Conta vitalícia concedida pela Fontes Business não é cobrada.',
        'O aplicativo não cobra cartão. Se a assinatura estiver pendente, ele pede para concluir em pila.fontes.business.',
      ],
    },
    {
      heading: 'O que cada um se compromete',
      paragraphs: [
        'O assinante informa dados verdadeiros e guarda a senha. Cada pessoa da casa usa o próprio acesso. O conteúdo lançado é de responsabilidade de quem o registrou.',
        'Não é permitido usar o Pila para fraude, invadir outra casa ou enviar mensagens de WhatsApp sem o aceite de quem recebe.',
      ],
    },
    {
      heading: 'WhatsApp e inteligência',
      paragraphs: [
        'O WhatsApp usa a Evolution API e não é o aplicativo oficial da Meta. A conexão é de cada pessoa, depois do termo mostrado na própria tela.',
        'A análise com inteligência artificial depende da chave e do modelo escolhidos pelo assinante. Sem chave, essa função fica indisponível.',
      ],
    },
    {
      heading: 'Encerramento',
      paragraphs: [
        'A Fontes Business pode suspender uma casa que descumpra estes termos ou que esteja com o pagamento em atraso. O assinante pode encerrar a assinatura. Estes termos valem junto com a Política de privacidade.',
        'Dúvidas: contato@fontes.business.',
      ],
    },
  ],
}
